import { combineReducers } from 'redux';
import * as types from './types';
import type { SharedState } from './types';
import initialState from './initialState';

type Action = { type: string; payload?: any };

const defaultAction = { type: '' };

const appSettingsReducer = (
  state = initialState.appSettings,
  action: Action = defaultAction
): SharedState['appSettings'] => {
  switch (action.type) {
    case types.FETCH_APP_SETTINGS_SUCCESS:
    case types.UPDATE_APP_SETTINGS:
      return {
        ...state,
        Account2Config: {
          ...state.Account2Config,
          ...action.payload.Account2Config
        }
      };
    default:
      return state;
  }
};

const getAppSettingsReducer = (
  state = initialState.getAppSettings,
  action: Action = defaultAction
): SharedState['getAppSettings'] => {
  switch (action.type) {
    case types.FETCH_APP_SETTINGS_BEGIN:
      return {
        ...initialState.getAppSettings,
        isLoading: true
      };
    case types.FETCH_APP_SETTINGS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.FETCH_APP_SETTINGS_SUCCESS:
      return {
        ...state,
        isLoading: false
      };
    default:
      return state;
  }
};

const reducer = combineReducers({
  appSettings: appSettingsReducer,
  getAppSettings: getAppSettingsReducer
});

export default reducer;
